<template>
  <div v-if="!loading">
    <div class="w-100 d-flex align-items-center flex-column mt-4">
      <input
        id="file"
        type="file"
        @change="fileUploaded()"
        ref="file"
        name="file"
        accept="application/pdf"
        class="d-none"
      />
      <label
        for="file"
        class="d-flex align-items-center justify-content-between"
      >
        <div
          class="choose-file-btn rounded px-5 py-2 fs-14 shadow-sm border border-primary align-items-center justify-content-center"
        >
          <span class="text-primary">{{ $t("actions.pick_file") }}</span>
        </div>
        <span class="label fs-14 text-form-grey ml-2">
          <span v-if="checkFile">{{ fileName }}</span>
        </span>
      </label>
      <p v-if="checkFile" class="mt-4 font-weight-bold">
        {{ $t("messages.import_pdf") }}
      </p>
      <b-button
        variant="primary"
        :disabled="!checkFile"
        class="mt-4"
        @click.stop="replacePdf"
      >
        {{ $t("actions.submit") }}
      </b-button>
    </div>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import api from '@/api/proposal'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    api,
    loading: true,
    form: {
      file: null,
      id: null
    },
    fileName: null
  }),
  created() {
    this.init()
    this.form.id = this.items.id
  },
  computed: {
    ...mapGetters({
      items: 'form/relationshipFields'
    }),
    formData() {
      var data = new FormData()
      Object.entries(this.form).forEach(([key, value]) =>
        data.append(
          key,
          typeof value === 'object' && ['file'].indexOf(key) === -1
            ? JSON.stringify(value)
            : value
        )
      )
      return data
    },
    checkFile() {
      return this.form.file
    }
  },
  methods: {
    init() {
      this.loading = false
    },
    fileUploaded() {
      this.form.file = this.$refs.file.files[0]
      this.fileName = this.form.file.name
    },
    async replacePdf() {
      this.loading = true

      try {
        const response = await this.api.upload(this.formData)

        if (response && response.data && response.data) {
          this.$toasted.success(this.$t('messages.updated', { item: 'PDF' }))
          this.form.file = null
          this.fileName = null
          this.items.file = this.form.file
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.choose-file-btn {
  cursor: pointer;
}
</style>
